import { mapGetters, mapActions } from 'vuex';

import ContentCategory from '@/helpers/contentCategory';

export default {
  props: {
    topic: {
      type    : Object,
      default : () => ({})
    }
  },
  computed: {
    ...mapGetters({
      getterSelectedTopic : 'plataforma/enrollment/getterSelectedTopic',
      isImpersonated      : '_core/auth/isImpersonated'
    }),
    isViewed() {
      if (this.getterSelectedTopic.categoryTypeId === ContentCategory.ORGANIZATION) {
        const topic = this.getterSelectedTopic.children.find(item => item.id === this.topic.id);

        return topic?.viewed;
      }

      return this.getterSelectedTopic.viewed;
    }
  },
  methods: {
    ...mapActions({
      actionAddProgress: 'plataforma/enrollment/actionAddProgress'
    }),
    isTooltipDisabled() {
      return !this.isImpersonated && this.topic.isBeforeDeadline && (
        this.topic.categoryTypeId !== ContentCategory.OBJECTIVE_EXERCISE &&
        this.topic.categoryTypeId !== ContentCategory.DISCURSIVE_EXERCISE &&
        this.topic.categoryTypeId !== ContentCategory.WEBCONFERENCE &&
        this.topic.categoryTypeId !== ContentCategory.FORUM &&
        this.topic.categoryTypeId !== ContentCategory.EXERCISE &&
        this.topic.categoryTypeId !== ContentCategory.LTI
      );
    },
    getTooltipMessage() {
      if (this.isImpersonated) {
        return this.$t('users.impersonate.progressTooltipText');
      } else if (!this.topic.isBeforeDeadline) {
        return this.$t('student.markProgress.cantMarkAsCompletedEnrollmentOrTopicExpired');
      } else {
        return this.$t('student.markProgress.cantMarkAsCompleted');
      }
    },
    shouldEmitEvent() {
      return this.isTooltipDisabled() && !this.topic.viewed;
    },
    async emitProgress() {
      if (this.shouldEmitEvent() && !this.isImpersonated && this.topic.isBeforeDeadline) {
        await this.actionAddProgress({ topicId: this.topic.id, enrollmentId: this.$route.params.id });

        this.topic.viewed = true;
      }
    },
    btnClass() {
      if (this.topic.viewed || this.isViewed) {
        return this.isTooltipDisabled() ? 'btn-viewed' : 'btn-viewed-disabled';
      } else if (!this.isTooltipDisabled()) {
        return 'btn-not-viewed-disabled';
      } else {
        return 'btn-not-viewed';
      }
    }
  }
};
